import { useEffect, useMemo } from 'react';
import { Box, Typography, Button } from '@mui/material';
import useAuth from '../../../hooks/useAuth';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const NotFound = (props) => {

  const { isLogout } = props;

  const { logout } = useAuth();

  const theme = useTheme();

  const linkTheme = useMemo(() => ({
    textDecoration: 'none', color: 'black'
  }), []);

  const buttonTheme = useMemo(() => ({
    mt: 1,
    color: 'white',
    backgroundColor: theme.mainColor,
    fontSize: 18,
    fontWeight: 'bold',
    borderRadius: 2,
    height: "45px",
    '&:hover': {
      backgroundColor: '#b30000',
      color: 'white',
      fontSize: 18,
      fontWeight: 'bold',
      borderRadius: 2,
    },
  }), [theme.mainColor]);

  useEffect(() => {
    if (isLogout) {
      logout('/logout');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="80vh"
      sx={{
        p: 4
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
      >
        <Typography variant="h4" component="h1" gutterBottom>
          {isLogout ? "Unauthorized Action" : "Oops! This Page Could Not Be Found"}
        </Typography>
        <Typography variant="h6" sx={{ mb: 3 }}>
          {isLogout ? "You have been logged out. Please log in again." : "Sorry, but the page you are looking for does not exist or has been removed"}
        </Typography>
        <Link to='/' style={{ ...linkTheme }}>
          <Button sx={{ ...buttonTheme }} >
            GO TO HOMEPAGE
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default NotFound;
